<app-template [isContentColorWhite]="false">
  <div class="settings" [formGroup]="settingsForm">
    <ng-container *skeleton="!(settingsInitialized$ | async); height: '10em';">
      <div>
        <h2>Kontoeinstellungen</h2>
        <p class="auto-save-info">Änderungen werden automatisch gespeichert.</p>
      </div>

      <div class="form-group">
        <label class="field-label">Verfahren pro Seite</label>
        <mat-form-field appearance="fill" class="form-field">
          <mat-select id="itemsPerPage" formControlName="itemsPerPage" (selectionChange)="updateItemsPerPage()">
            <mat-option *ngFor="let option of paginatorOptions" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-group-horizontal">
        <label>
          Möchten Sie E-Mails zu wichtigen Neuigkeiten bekommen?
          (z.B. größere Updates oder anstehende Informationsveranstaltungen)
        </label>
        <mat-slide-toggle
          formControlName="newsletterOptIn"
          (change)="updateNewsletterOptIn()">
        </mat-slide-toggle>
      </div>
    </ng-container>
  </div>
</app-template>
